/**
 * Structural guard for Firestore Timestamps read from untyped snapshot data.
 * Used instead of `instanceof Timestamp` so the same code path handles both
 * real Timestamps and anything Timestamp-shaped from cached/emulated reads.
 */

/**
 * Extracts epoch milliseconds from a Firestore Timestamp-shaped value.
 *
 * @param value - Possibly a Firestore Timestamp (anything with `toMillis`).
 * @return Epoch millis, or null when the value is not Timestamp-shaped.
 */
export function toMillisOrNull(value: unknown): number | null {
  if (typeof value !== 'object' || value === null || !('toMillis' in value)) {
    return null;
  }
  const {toMillis} = value;
  if (typeof toMillis !== 'function') {
    return null;
  }
  const millis: unknown = toMillis.call(value);
  return typeof millis === 'number' ? millis : null;
}
